var chunkToChildrenMap = {
	"132": [
		5947
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};